<template>
  <b-container fluid class="animated fadeIn">
    <h1>Exemplo</h1>

    <b-card>
      <div slot="header">
        <b>Exemplo de formulário</b>
        <!-- <b-badge variant="mute" class="float-right small">(*) Obrigatório</b-badge> -->
      </div>

      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-between">
          <div>
            <b-button class="mx-1" variant="outline-primary"><i class="fa fa-plus"></i> Incluir</b-button> 
            <b-button class="mx-1" variant="outline-primary"><i class="fa fa-share"></i> Encaminhar</b-button> 
            <b-button class="mx-1" variant="outline-primary"><i class="fa fa-archive"></i> Guardar</b-button> 
          </div>
            <b-button class="mx-1" v-b-toggle.collapse-1 variant="primary"><i class="fa fa-filter"></i> Opções de pesquisa</b-button>
          </div>
          <div>
            <b-collapse id="collapse-1" class="mt-2">
              <b-card class="primary-semi">
                <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                  <b-form-group
                    label="Nº do contrato:"
                    label-for="numeroContrato"
                    class="text-label"
                  >
                    <b-form-input
                      id="numeroContrato"
                      v-model="filtro.numeroContrato"
                      maxlength="20"
                    />
                  </b-form-group>
                </b-col>

                <b-col xs="12" sm="12" md="12" lg="12" xl="6">
                  <b-form-group label="Nome:" label-for="nome" class="text-label">
                    <b-form-input id="nome" v-model="filtro.nome" maxlength="100" />
                  </b-form-group>
                </b-col>

                <b-col xs="12" sm="12" md="12" lg="9" xl="6">
                  <b-form-group label="Operador:" label-for="operador" class="text-label">
                    <multiselect
                      v-model="filtro.operador"
                      :show-labels="false"
                      :options="operadorOptions"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Selecione"
                      label="text"
                      track-by="val"
                    >
                      <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span
                          class="multiselect__single"
                          v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} selecionado(s)</span>
                      </template>
                    </multiselect>
                  </b-form-group>
                </b-col>
              </b-card>
            </b-collapse>
          </div>
        </b-col>
      </b-row>

      <em slot="footer">
        <div class="d-flex justify-content-center align-items-center">
          <b-button variant="primary">
            <i class="fa fa-search"></i> Pesquisar
          </b-button>
          <b-button variant="secondary">
            <i class="fa fa-eraser"></i> Limpar
          </b-button>
        </div>
      </em>
    </b-card>

    <Lista :lista-sincronismo="resultado" />
  </b-container>
</template>

<script>
import Lista from "./components/CompLista.vue";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    Lista
  },
  data() {
    return {
      filtro: {
        numeroContrato: "",
        tipoOperacao: null,
        chassi: "",
        nome: "",
        operador: null,
        situacao: null
      },
      // situacao: [],
      situacaoOptions: [
        { text: "Em análise", val: "EM_ANALISE" },
        { text: "Erro de comunicação", val: "ERRO_COMUNICACAO" },
        { text: "Dados incompletos", val: "DADOS_INCOMPLETOS" },
        { text: "Concluído", val: "CONCLUIDO" }
      ],
      // operador: [],
      operadorOptions: [
        { text: "Carolina Oliveira", val: "1" },
        { text: "Rubens Meneghel", val: "2" },
        { text: "Andressa Fonseca", val: "3" },
        { text: "Paulo Soares", val: "4" },
        { text: "Jorge Silva", val: "5" },
        { text: "Tatiana Lima", val: "6" }
      ],
      resultado: []
    };
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.badge {
  font-size: 0.9rem;
}
</style>
